import type { Styles } from 'src/theme/themes';

export const styles = {
  root: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingBlock: theme.spacing(8),
    paddingInline: theme.spacing(12),
  }),
  settingsContainer: { display: 'flex', flexDirection: 'column', gap: 6 },
  settingsGroup: (theme) => ({
    border: 'solid 1px',
    borderColor: theme.colors.neutral[200],
    borderRadius: 2,
  }),
  settingsGroupContent: () => ({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: 2,
  }),
  settingsGroupHeader: (theme) => ({
    backgroundColor: theme.colors.neutral[50],
    border: 'solid 1px',
    borderColor: theme.colors.neutral[200],
    padding: theme.spacing(1),
  }),
  rootCausesSettings: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  }),
  addRootCauseInput: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    maxWidth: '25rem',
    '& .MuiInputBase-root': { padding: '8px 14px' },
    '& .MuiInputBase-input': { padding: 0 },
  },
  addRootCauseButton: (theme) => ({
    minWidth: 'min-content',
    '&.Mui-disabled': {
      backgroundColor: theme.colors.neutral[100],
      color: theme.colors.neutral[400],
    },
  }),
  rootCauseEditWarning: (theme) => ({
    backgroundColor: theme.colors.primary[50],
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    paddingBlock: theme.spacing(0.75),
    paddingInline: theme.spacing(1.5),
    width: 'max-content',
  }),
  followUpEditsContainer: (theme) => ({
    columnGap: 3,
    display: 'grid',
    gridAutoRows: '1fr',
    gridTemplateColumns: 'repeat(3, 25rem)',
    rowGap: 2,
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(2, 25rem)',
    },
  }),
  rootCauseEdit: {
    display: 'grid',
    gap: 1,
    gridTemplateColumns: 'max-content 1fr max-content',
    height: 'min-content',
  },
  formFieldEdit: (theme) => ({
    border: 'solid 1px',
    borderColor: theme.colors.neutral[200],
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
    padding: theme.spacing(1.25),
    minHeight: '16rem',
  }),
  addNewFormField: (theme) => ({
    alignItems: 'center',
    border: 'solid 1px',
    borderColor: theme.colors.neutral[200],
    borderRadius: '8px',
    display: 'flex',
    flexGrow: 2,
    justifyContent: 'center',
    marginTop: '2rem',
  }),
} satisfies Styles;
